<template>
  <div>
    <div class="h-dialogContainer fl h-mml-dldInput">
      <template>
        <div v-for="(item, index) in expandData" :key="index">
          <div class="h-borderBox h-subscriber-parseList h-dp-deploy-style">
            <div class="h-dialog-borderBox-topIcon">
              {{item.description}}
              <div class="h-toolbarBg dialog-icon-style">
                <ejs-toolbar class="dialog-icon-style">
                  <div class="dialog-icon-style"></div>
                </ejs-toolbar>
              </div>
            </div>
            <div class="h-borderBox-content" style="overflow: hidden">
              <div class="h-subscriber-listArr h-subscriber-listParseForm" style="border:none;margin-left:0;padding: 0 20px;width:100%;">              
                <ParseForm
                  :ref="item.key"
                  :formId="item.key"
                  :formParams="item.resultVal"
                  :opCode="parseOpCode"
                ></ParseForm>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ParseForm from "../../subscriberconfig/util/parseFormNew/ParseForm";
import SubscriberTool from "../../subscriberconfig/util/parseFormNew/tools/subscriberTool";
import ajaxUrl from "../../subscriberconfig/data/ajaxUrl";
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "ExpandCapacityDialog",
  components: {
    ParseForm
  },
  methods: {
     getDatas() {
      const map = new Map();
      for (var i = 0; i < this.expandData.length; i++) {
        const key = this.expandData[i].key;
        if (this.$refs[`${key}`][0]) {
          if (!this.$refs[`${key}`][0].validateResult()) {
            console.log("表单验证不通过");
            return;
          }
          const maps = this.$refs[`${key}`][0].getDatas();
          for (const [key, value] of maps.entries()) {
            map.set(key, value);
          }
        }
      }
      console.log("maps", map);
      return map;
    },
    getJson(id, name,envID,callback) {
      console.log("id-------",id)
      console.log("name-------",name)
      this.idParam=id;
      this.nameParam=name;
      //产品侧获取json数据
      this.$axios
        .get(`/lte/ems/topo/ne/findNe/${this.idParam}`)
        .then(response => {
          const json = {
            info: {
              method: {
                getNodeNameIp: "/lte/ems/env/getNodeNameIp",
                getLabels: "/lte/ems/env/getLabels",
                getTaints: "/lte/ems/env/getTaints"
              }
            },
            vo: [
              {
                key: "helm-nginx-chart",
                description: "helm chart package values.yaml",
                type: "array",
                resultVal: [
                  {
                    validate: {
                      required: [false, ""]
                    },
                    id: "Values.imageRegistry1",
                    name: "Values.imageRegistry",
                    showName: "ImageRegistry",
                    placeholder: "Application image registry",
                    valueType: "string",
                    value: "",
                    uiIndex: 0,
                    type: "text",
                    hidden: false,
                    groupBy: "基础"
                  },
                  {
                    validate: {
                      required: [true, "该项不能为空"]
                    },
                    id: "Values.cpu",
                    name: "Values.cpu",
                    showName: "CPU",
                    placeholder: "CPUs of each node",
                    valueType: "integer",
                    value: "",
                    type: "checkbox",
                    method: "getNodeNameIp",
                    uiIndex: 1,
                    hidden: false,
                    groupBy: "基础"
                  },
                  {
                    validate: {
                      required: [true, "该项不能为空"]
                    },
                    id: "Values.memory",
                    name: "Values.memory",
                    showName: "Memory",
                    placeholder: "Memory of each node (in MiB)",
                    valueType: "integer",
                    value: "",
                    type: "checkbox",
                    method: "getLabels",
                    uiIndex: 2,
                    hidden: false,
                    groupBy: "基础"
                  },
                  {
                    validate: {
                      required: [false, ""]
                    },
                    id: "Values.tolerations",
                    name: "Values.tolerations",
                    showName: "tolerations",
                    placeholder: "tolerations",
                    valueType: "string",
                    value: "GetTolerations",
                    warn:
                      "//key-value的形式，且有这个Values.tolerations就必须有上面Values.nodeSelector",
                    uiIndex: 5,
                    hidden: false,
                    type: "text",
                    groupBy: "调度"
                  },
                  {
                    validate: {
                      required: [false, ""]
                    },
                    id: "Values.metrics.targetAverageUtilization",
                    name: "Values.metrics.targetAverageUtilization",
                    showName: "横向自动扩容CPU指标",
                    placeholder: "autoscaling hpa cpu targetAverageUtilization",
                    valueType: "integer",
                    value: "200",
                    uiIndex: 6,
                    hidden: false,
                    type: "text",
                    groupBy: "调度"
                  },
                  {
                    validate: {
                      required: [true, "该项不能为空"]
                    },
                    id: "Values.77cpu",
                    name: "Values.77cpu",
                    showName: "77CPU",
                    placeholder: "CPUs of each node",
                    valueType: "integer",
                    value: "",
                    type: "checkbox",
                    // "method":"todoMethod",
                    uiIndex: 1,
                    hidden: false,
                    options: [
                      {
                        showName: "SSC_MODE_1",
                        value: "k8s"
                      },
                      {
                        showName: "SSC_MODE_2",
                        value: "1"
                      },
                      {
                        showName: "SSC_MODE_3",
                        value: 2
                      }
                    ],
                    groupBy: "伸缩"
                  },
                  {
                    uiIndex: 8,
                    showName: "副本数",
                    hidden: false,
                    type: "text",
                    name: "Values.replicaCount",
                    id: "Values.replicaCount",
                    value: 1,
                    valueType: "int",
                    groupBy: "伸缩"
                  }
                ]
              },
              {
                key: "helm-amf-chart",
                description: "helm1 chart package values.yaml",
                type: "array",
                resultVal: [
                  {
                    validate: {
                      required: [false, ""]
                    },
                    id: "Values.imageRegistry",
                    name: "Values.imageRegistry",
                    showName: "ImageRegistry",
                    placeholder: "Application image registry",
                    valueType: "string",
                    value: "",
                    uiIndex: 0,
                    hidden: false,
                    type: "text",
                    groupBy: "基础"
                  },
                  {
                    hidden: false,
                    validate: {
                      required: [true, "该项不能为空"]
                    },
                    id: "Values.cpu",
                    name: "Values.cpu",
                    showName: "CPU",
                    placeholder: "CPUs of each node",
                    valueType: "integer",
                    value: 100,
                    type: "radio",
                    options: [
                      {
                        showName: 1,
                        value: 1
                      },
                      {
                        showName: 2,
                        value: 2
                      },
                      {
                        showName: 4,
                        value: 4
                      },
                      {
                        showName: 8,
                        value: 8
                      },
                      {
                        showName: 16,
                        value: 16
                      }
                    ],
                    uiIndex: 1,
                    groupBy: "伸缩"
                  },
                  {
                    hidden: false,
                    validate: {
                      required: [true, "该项不能为空"]
                    },
                    id: "Values.memory",
                    name: "Values.memory",
                    showName: "Memory",
                    placeholder: "Memory of each node (in MiB)",
                    valueType: "integer",
                    value: 2048,
                    type: "radio",
                    options: [
                      {
                        showName: 2048,
                        value: 2048
                      },
                      {
                        showName: 8192,
                        value: 8192
                      },
                      {
                        showName: 16384,
                        value: 16384
                      },
                      {
                        showName: 32768,
                        value: 32768
                      },
                      {
                        showName: 49152,
                        value: 49152
                      }
                    ],
                    uiIndex: 2,
                    groupBy: "伸缩"
                  },
                  {
                    hidden: false,
                    validate: {
                      regex: ["{1,2,3}\\d", "无效的特殊字符"],
                      required: [true, "该项不能为空"]
                    },
                    id: "Values.Disk",
                    name: "Values.Disk",
                    showName: "Disk",
                    placeholder: "Disk of each node (in MiB)",
                    valueType: "integer",
                    value: 2048,
                    type: "radio",
                    options: [
                      {
                        showName: 2048,
                        value: 2048
                      },
                      {
                        showName: 8192,
                        value: 8192
                      },
                      {
                        showName: 16384,
                        value: 16384
                      },
                      {
                        showName: 32768,
                        value: 32768
                      },
                      {
                        showName: 49152,
                        value: 49152
                      }
                    ],
                    separator: ",",
                    uiIndex: 3,
                    groupBy: "伸缩"
                  },
                  {
                    uiIndex: 4,
                    showName: "副本数",
                    hidden: false,
                    type: "text",
                    name: "Values.replicaCount",
                    id: "Values.replicaCount",
                    value: 2,
                    valueType: "int",
                    groupBy: "伸缩"
                  }
                ]
              },
              {
                key: "helm-amf3-chart",
                description: "helm3 chart package values.yaml",
                type: "array",
                resultVal: [
                  {
                    // uiIndex: 1,
                    // showName: "副本数",
                    // hidden: false,
                    // type: "text",
                    // name: "Values.replicaCount",
                    // id: "Values.replicaCount",
                    // value: 3,
                    // valueType: "int",
                    // groupBy: "伸缩"
                  }
                ]
              },
              {
                key: "helm-amf4-chart",
                description: "helm4 chart package values.yaml",
                type: "array",
                resultVal: [
                  {
                    uiIndex: 1,
                    showName: "副本数",
                    hidden: false,
                    type: "text",
                    name: "Values.replicaCount4",
                    id: "Values.replicaCount4",
                    value: 3,
                    valueType: "int",
                    groupBy: "伸缩"
                  }
                ]
              }

            ]
          };
          // const res = json.vo; //假数据
          // this.sourceData = json.vo;
          // this.infoParam = json.info;
          // this.ipParam = json.info.ip;
          // this.expandShowData = json.vo;
          // this.expandData = json.vo;

          const res = response.data.resultVal; //实际数据
          const str1 = JSON.parse(res.k8sServiceTemplate);
          this.sourceData = JSON.parse(JSON.stringify(str1.vo));
             console.log("sourceData00&&&&&",this.sourceData)
          this.infoParam = str1.info;
          this.ipParam = str1.info.ip;
          this.expandShowData = JSON.parse(JSON.stringify(str1.vo));

          let replicaCountAll=0;
          for (var i = 0; i < this.expandShowData.length; i++) {
            const replicaCount=0;
            for (var j = 0; j < this.expandShowData[i].resultVal.length; j++) {  
              if("Values.replicaCount"!==this.expandShowData[i].resultVal[j].id){//目前副本数按照一个chart下只有一个做
                 this.expandShowData[i].resultVal[j].hidden=true;//一个chart只留一个数据副本数
              }
              else if("Values.replicaCount"===this.expandShowData[i].resultVal[j].id){
                              //副本数据name变成唯一键值
                 this.expandShowData[i].resultVal[j].name =this.expandShowData[i].key + this.expandShowData[i].resultVal[j].name;
                 replicaCount++;
                 replicaCountAll++;
              }
            }
            if(replicaCount!==0){
             this.expandData.push(this.expandShowData[i]);
            }        
          }
          //没有副本数不弹窗
          if(replicaCountAll!==0){
           if (callback) {
            callback(true);
          }
          }
          else {
           if (callback) {
            callback(false);
          }
            }  
        });

                //获取IP
       this.$axios
       .get("/lte/ems/env/getEnvironmentIngressIp?envid="+envID)
       .then(responsePath => {
           console.log("responsePath==",responsePath.data.resultVal[0])
        this.envIDParam=responsePath.data.resultVal[0].ingressIp;
                   console.log("envIDParam==",this.envIDParam)
                  // this.$set(this.infoParam, "ip", this.envIDParam); //增加新属性
        // this.$forceUpdate();

        // this.infoParam.ip=this.envIDParam;
                   console.log("infoParam==",this.infoParam)

        });
    },
    saveProfile(callback) {
      console.log("sourceData&&&&&",this.sourceData)
      console.log("expandShowData&&&&&&",this.expandData)
      const formData = this.getDatas();
      if (formData) {
        for (var i = 0; i < this.sourceData.length; i++) {
          for (var j = 0; j < this.sourceData[i].resultVal.length; j++) {
            let chartEvery = this.sourceData[i];
            let resultValEvery = this.sourceData[i].resultVal[j];
            // let sourceName = resultValEvery.name;
            if(resultValEvery.name==="Values.replicaCount"){//每个chart里的唯一副本数赋值
            let idValue = formData.get(chartEvery.key+"Values.replicaCount");
            if(undefined!==idValue){
              resultValEvery.value = idValue; //表单数据付给value            
             // resultValEvery.name = resultValEvery.id; //name变回原值
              }
            }

          }
        }

        const params = {
          vo:  this.sourceData,
          // info:this.infoParam,
                    info: {
            processName: this.infoParam.processName,
            ip: this.envIDParam,
            alias: this.infoParam.alias, //别名用户自定义
            serviceName: this.infoParam.serviceName, //实例名称
            id: this.infoParam.id,
            method: this.infoParam.method,
            chart_url: this.infoParam.chart_url,
            path: this.infoParam.path,
            pkgVersion: this.infoParam.pkgVersion,
            description: this.infoParam.description
          },
          id:this.idParam,
          name:this.nameParam,
        };
        console.log("params", params);
        this.$axios.post("/lte/ems/deployed/scale", params).then(response => {
          console.log("responseobj", JSON.parse(response.data.resultVal));
          const obj = JSON.parse(response.data.resultVal);//早期数据适应
          // console.log("responseobj", response.data.resultVal);
          // const obj = response.data.resultVal;
          if (undefined === obj.code) {
            EventBus.$emit("toast", {
              type: "success",
              content: this.$t("Alarm.success")
            });
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: obj.code + ":" + obj.message
            });
          }
          if (callback) {
            callback(response);
          }
        });
      }
    }
  },
  data() {
    return {
      opCode: "add",
      idParam: "",
      nameParam: "",
      envIDParam: "",
      // configPath: "",
      // chartUrl: "",
      ipParam: "",
      sourceData: [],
      infoParam: {},
      expandShowData: [],
      expandData: [],
    };
  },
  computed: {
    parseOpCode() {
      return this.opCode + "";
    }
  }
};
</script>
